/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Due_DateInputs */



/**
* | output |
* | --- |
* | "Due Date" |
*
* @param {Explorer_Info_Property_Due_DateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_due_date = /** @type {((inputs?: Explorer_Info_Property_Due_DateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Due_DateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "de") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "it") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "es") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Due Date")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Due Date")
	return /** @type {LocalizedString} */ ("Due Date")
});